export default "/institutions/santander.svg";